import { targetIcon, searchPlusIcon } from "@/lib/icons";
import ProductTile from "@/components/product_tile";
import Link from "next/link";

export default function ApplicationPhotoFeaturedProducts(props){
  const sameProductTaggedCriteria = (product) => {
    let q = {};
    q['product_hot_spots_product_id_eq'] = product.id;
    return q;
  }

  return (
    <div className='featured-products-container'>
      <div className='featured-products-heading-container'>
        <h4 className='featured-products-heading'>Products: </h4>
      </div>
      <p className='featured-products-subheading'>
        { targetIcon }
        This application photo includes the following products:</p>
       { props.product_hot_spots?.length > 0 &&
        <>
        <div className='lexcms-app-photo-product-list'>
          <div className='lexcms-product-tile-grid-container'>
          {  props.product_hot_spots?.map((hot_spot, i) => {
              return (
                <div className="lexcms-product-tile-container" key={i}>
                  <ProductTile
                    product={hot_spot.product} 
                    key={i}
                    hotSpotDisplay={props.hotSpotClickId == hot_spot.product.id} />
                  { hot_spot.more_photos_containing_product &&
                    <Link href={{
                      pathname: '/lex-cms/inspiration/application_photos/index',
                      query: sameProductTaggedCriteria(hot_spot.product)
                    }}>
                      <a className="photos-same-product-tagged-button">
                        { searchPlusIcon }
                        <p>Search images that include this product.</p>
                      </a>
                    </Link>
                  }
                </div>
              );
            })
          }
          </div>
        </div>
        {/* <div className='action-buttons-container'>
          <SaveAllProductsButton product_ids={props.product_hot_spots.map((d, ) => d.product.id )} />
        </div> */}
        </>
      }
     
    </div>
  )
}